module.exports = __webpack_public_path__ + "img/icon-telegram.e543c60a.svg";